import React from "react";

export const Status: React.FC = () => (
  <section className="mt-5">
    <h2>Current Status</h2>
    <p className="text-base ml-3">
      I am doing an internship as a backend engineer.<br />
      I don't accept job requests, sorry.
    </p>
  </section>
);
